import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { zUsdMicros } from "../../currency";
import { billingStatsSchema } from "../itemized-invoice-types";

export type CreateBilledTrackingOrder = Omit<BilledTrackingOrder, "_id">;
export type BilledTrackingOrder = z.infer<typeof billedTrackingOrderSchema>;
export const billedTrackingOrderSchema = z.object({
  _id: zExt.objectId(),
  teamId: zExt.objectId(),
  orderId: zExt.objectId(),
  orderNumber: z.string(),
  billingWindowConfigId: zExt.objectId(),
  trackingNumbers: z.array(z.string()),
  shopifyCreatedAt: z.coerce.date(),
  orderCostMicros: zUsdMicros,
  smsStats: billingStatsSchema,
  emailStats: billingStatsSchema,
});
